export default __webpack_public_path__ + "static/media/nv12.27c510b9.PNG";